import {actionTypes} from '../const';
const initialState = {
    coverStatus:false
}
const coverLoadingState = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.COVER_LOADING:
            return Object.assign({}, state, {
                coverStatus:action.coverStatus
        });
        default:
            return state;
    }
}
export default coverLoadingState